<template>
<div>
    <slot></slot>
</div>
</template>

<script>
import { useGlobalActionsStore } from './stores/GlobalActionsStore'
export default {
    props:['stretch_time_globally'],
    mounted(){
        useGlobalActionsStore().globalConfig.stretchTimeGlobal = this.stretch_time_globally;
    }
}
</script>

<style>

</style>
